// extracted by mini-css-extract-plugin
export default {"handle":"drag-handle_handle__HaV8e"};